export const PRIMARY = "#26A69A";
export const SECONDARY = "#B2DFDB";
export const COMPLEMENTARY = "#96000f";
